import Icon from '../components/Icon';

const Check = Icon(
  'check',
  <>
    <path d="M21.034 5.974a.75.75 0 0 1-.008 1.06l-10.734 10.58a.75.75 0 0 1-1.047.006l-5.266-5.08a.75.75 0 1 1 1.042-1.08l4.739 4.573L19.974 5.966a.75.75 0 0 1 1.06.008" />
  </>
);

export default Check;
